import React from 'react';
import { Button } from '../Button/Button';
import { useConfirmation } from './ConfirmationPrompt';

export function PromptExample(): JSX.Element {
  const { confirm } = useConfirmation({
    action: () => {
      alert('You actually did it... wow!');
    },
  });

  return (
    <div>
      <Button onClick={() => confirm()} title="Open Prompt" />
    </div>
  );
}
